import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { resolveRouterPath } from '../router';


import { waStyles } from '../styles/wa-styles';
import '@web.awesome.me/webawesome-pro/dist/components/button/button.js';
import '@web.awesome.me/webawesome-pro/dist/components/dialog/dialog.js';

@customElement('about-modal')
export class AboutModal extends LitElement {
  @property({ type: Boolean }) isOpen: boolean = false;
  @property({ type: String }) message: string = '';

  static styles = [
    waStyles
  ]

  open(message: string) {
    this.message = message;
    this.isOpen = true;
  }

  close() {
    this.dispatchEvent(new CustomEvent('close'));
    this.isOpen = false;
  }

  render() {
    if (!this.isOpen) {
      return html``;
    }

    return html`
      <wa-dialog
        label="About"
        ?open=${this.isOpen}
        @wa-after-hide=${(e: Event) => e.target === e.currentTarget && this.close()}
      >
        <p>${this.message}</p>
        <wa-button slot="footer" appearance="plain" href="${resolveRouterPath('about')}">
          Read More
        </wa-button>
        <wa-button slot="footer" variant="brand" @click=${this.close}>
          Thanks
        </wa-button>
      </wa-dialog>
    `;
  }
}
